export { renderAvatarGroup_unstable as renderAvatarGroup } from '@fluentui/react-avatar';
